import { Link } from 'react-router-dom';
import { Logo } from './Logo';

const INSTALL_URL = 'https://online.moysklad.ru/app/#apps?id=c5652470-2668-4096-ac28-cf73b6ef6592';

const NAV = [
  { href: '/#product', label: 'Продукт' },
  { href: '/#features', label: 'Возможности' },
  { href: '/docs', label: 'Инструкция' },
  { href: '/#about', label: 'О нас' },
  { href: '/#contacts', label: 'Контакты' },
];

export const Header = (): React.JSX.Element => {
  return (
    <header className="sticky top-0 z-40 border-b border-ink-800 bg-ink-950/80 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2" aria-label="ION home">
          <Logo />
          <span className="hidden md:flex flex-col justify-center text-ink-400 text-[11px] leading-[1.25] uppercase tracking-[0.2em]">
            <span>Intelligent</span>
            <span>Operations&nbsp;Network</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm text-ink-200">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} className="hover:text-white transition-colors">
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href={INSTALL_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 rounded-md bg-accent hover:bg-accent-hover px-4 py-2 text-sm font-medium text-white transition-colors"
        >
          Установить из МойСклад
        </a>
      </div>
    </header>
  );
};
